import {
  vBoolean,
  vObject,
  vOptional,
  vOptionalDef,
  vPicklist,
  vPipe,
  vRegex,
  vString,
  vTransform,
} from '../../validation/index.ts'
import { freightClasses } from '../common.ts'
import { loadHazardDetailSchema } from '../hazard-detail.ts'
import { packagingTypes } from '../packaging-type.ts'
import { intSchema } from './common.ts'

const flagSchema = vOptionalDef(vBoolean(), false)

export const flatItemSchema = vObject({
  itemDescription: vOptional(vString()),
  itemWeight: vOptional(intSchema),
  itemFreightClass: vOptional(
    vPipe(
      vPicklist(freightClasses),
      vTransform(v => Number(v)),
    ),
  ),
  itemLength: vOptional(intSchema),
  itemWidth: vOptional(intSchema),
  itemHeight: vOptional(intSchema),
  itemPackagingType: vOptional(
    vPicklist(
      packagingTypes.filter(p => p.modes.includes('ltl')).map(p => p.key),
    ),
  ),
  itemQuantity: vOptional(intSchema),
  itemNmfc: vOptional(
    vPipe(vString(), vRegex(/[\d-]+/, 'Must match format ####-##')),
  ),
  itemStackableFlag: flagSchema,
  itemContainsQuantity: vOptional(intSchema),
  itemContainsPackagingType: vOptional(
    vPicklist(packagingTypes.filter(p => p.canBeContained).map(p => p.key)),
  ),
  itemHazardousFlag: flagSchema,
  itemHazmatId: vOptional(loadHazardDetailSchema.entries.hazmatId),
  itemHazardClass: vOptional(loadHazardDetailSchema.entries.primaryClass),
  itemSecondaryHazardClass: vOptional(
    loadHazardDetailSchema.entries.secondaryClass,
  ),
  itemTertiaryHazardClass: vOptional(
    loadHazardDetailSchema.entries.tertiaryClass,
  ),
  itemPackingGroup: vOptional(loadHazardDetailSchema.entries.packingGroup),
  itemHazmatSpecialPermit: vOptional(
    loadHazardDetailSchema.entries.permitNumber,
  ),
  itemProperShippingName: vOptional(vString()),
  itemTechnicalName: vOptional(loadHazardDetailSchema.entries.technicalName),
  itemReportableQuantityFlag: flagSchema,
  itemResidueLastContainedFlag: flagSchema,
  itemLimitedQuantityFlag: flagSchema,
  itemMarinePollutantFlag: flagSchema,
})
